import { render, staticRenderFns } from "./ApplicantsIndex.vue?vue&type=template&id=1edd8741"
import script from "./ApplicantsIndex.vue?vue&type=script&lang=js"
export * from "./ApplicantsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports